import { createSlice } from '@reduxjs/toolkit';
import { getDeviceName } from '@custom/rtk-apis/machine/getDevice';

const getDeviceNameSlice = createSlice({
    name: 'getDeviceNameSlice',
    initialState: {
      machinePayload: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      reset: (state) => {
        state.machinePayload = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(getDeviceName.getDeviceNameSlice.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(getDeviceName.getDeviceNameSlice.fulfilled, (state, action) => {
          state.machinePayload = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(getDeviceName.getDeviceNameSlice.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });

  export default getDeviceNameSlice.reducer;
  export const { reset } = getDeviceNameSlice.actions
